import React from 'react';
import { Form, Button } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { pushDataLayer } from '../gtm';
import { parseCantidadPendientes } from '../data/materiasPendientes';

export default function Step6_MateriasPendientes({ formData, setFormData, next, prev }) {
  const opcionesPorGrado = (grado) => [
    `No cursé ${grado} año aún`,
    "0", "1", "2", "3", "4", "5", "6", "7",
    "8 o más", "No recuerdo exactamente"
  ];
  const etiquetasPorGrado = {
    '4to': 'Materias de 4to año',
    '5to': '5to año de bachillerato',
    '6to': '6to año de bachillerato'
  };

  /* 2️⃣  Valida antes de avanzar */
  const handleNext = () => {
    const { pendientes4to, pendientes5to, pendientes6to } = formData;
    if (!pendientes4to || !pendientes5to || !pendientes6to) {
      Swal.fire({
        icon: 'warning',
        title: 'Campos incompletos',
        text: 'Por favor, seleccioná una opción para cada año.',
      });
      return;
    }

    pushDataLayer('paso8_materias_especificas');
    next();
  };


  /* 3️⃣  Manejador genérico para cada select */
  const handleChange = (grado) => (e) => {
    const valor = e.target.value;

    // Muestra el popup una sola vez
    if (valor === 'No recuerdo exactamente') {
      Swal.fire({
        icon: 'info',
        title: '¡Queremos acompañarte!',
        text: 'Por favor, dirigite al liceo público más cercano y solicitá tu escolaridad para saber cuántas materias te quedan y volvé a completar este formulario para que podamos apoyarte.',
        confirmButtonText: 'Entendido',
        confirmButtonColor: '#000000' 
      });
    }

    setFormData((prev) => {
      const currentSelection = prev.materiasPendientesSeleccionadas || {};
      const nextSelection = {
        ...currentSelection,
        [grado]: parseCantidadPendientes(valor) > 0
          ? (currentSelection[grado] || []).slice(0, parseCantidadPendientes(valor))
          : []
      };

      return {
        ...prev,
        [`pendientes${grado}`]: valor,
        materiasPendientesSeleccionadas: nextSelection
      };
    });
  };



  return (
    <div className="form-container">
      <h2 className="form-title">¿Cuántas materias pendientes tenés?</h2>
      <p style={{ fontSize: "12px", textAlign: "center" }}>
        Si ya aprobaste todas las materias de alguno de los grados poner 0
      </p>
      <Form>
        {["4to", "5to", "6to"].map((grado, i) => (
          <Form.Group className="mb-4" key={i}>
            <Form.Label>{etiquetasPorGrado[grado]}</Form.Label>
            <Form.Select
              value={formData[`pendientes${grado}`]}
              onChange={handleChange(grado)}
            >
              <option value="">Seleccioná una opción</option>
              {opcionesPorGrado(grado).map((op) => (
                <option key={op} value={op}>{op}</option>
              ))}
            </Form.Select>
          </Form.Group>
        ))}

        <div className="d-flex justify-content-between">
          <Button variant="secondary" onClick={prev}>Atrás</Button>
          <Button variant="primary" onClick={handleNext}>Aceptar</Button>
        </div>
      </Form>
    </div>
  );
}
